export default [
  {
    title: 'Portal User',
    subTitle: 'Create or Edit Users',
    content: ['Create a new user.', 'Update a previous users email address.', 'Or change a users password.'],
  },
];



/** WEBPACK FOOTER **
 ** ./src/helpers/managers/ManagersInfo.js
 **/